import {FRBase} from "#Formulas/FormulaCore/FRBase";
import {FRFactory} from "#Formulas/FormulaCore/FRFactory";


export class FRArray extends FRBase{
    public Items:FRBase[];
    constructor(Options: any, Parent: FRBase) {
        super(Options, Parent);
        this.Items=[];
        Options.d.forEach(item=>{
            this.Items.push(FRFactory.GetFRElement(item,this));
        })
    }

    Parse(): any {
        let items=[];

        return this.Iterate(this.Items,(item, index, onEnd) => {items.push(item)},()=>items);

    }

}

FRFactory.AddField('ARR',FRArray);